const booking = {
  booking: {
    title: 'Finalizar reserva',
    property: 'Propriedade',
    unit: 'Acomodação',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Hóspedes',
    nightsLabel: 'Noites',
    nightSingular: 'noite',
    nightPlural: 'noites',
    guestSingular: 'hóspede',
    guestPlural: 'hóspedes',
    serviceFee: 'Taxa de serviço',
    taxes: 'Impostos',
    discount: 'Desconto',
    total: 'Total',
    installments: 'Em até 12x no cartão',
    staySummary: 'Resumo da estadia',
    priceBreakdown: 'Detalhes do valor',
    guestInfo: 'Dados do hóspede',
    guestName: 'Nome completo',
    guestEmail: 'E-mail',
    guestPhone: 'Telefone / WhatsApp',
    guestPhoneLabel: 'Telefone',
    payment: 'Pagamento',
    paymentDetails: 'Dados do pagamento',
    payAmount: 'Pagar {{amount}}',
    payNow: 'Pagar com Cartão',
    processing: 'Processando...',
    processingPayment: 'Processando pagamento...',
    preparingPayment: 'Preparando pagamento...',
    continueToPayment: 'Continuar para pagamento',
    fillAllFields: 'Preencha todos os dados do hóspede para continuar',
    securePayment: 'Pagamento seguro via Stripe',
    secureReservation: 'Reserva segura via Reserve Connect',
    backToReview: 'Voltar e revisar dados',
    backToProperty: 'Voltar para propriedade',
    backToSearch: 'Voltar para busca',
    preparingReservation: 'Preparando sua reserva...',
    cannotProceed: 'Não foi possível prosseguir',
    incompleteInfo: 'Informações de reserva incompletas.',
    cannotCreateIntent: 'Não foi possível criar a intenção de reserva.',
    errorCreatingIntent: 'Erro ao criar intenção de reserva.',
    paymentCancelled: 'Pagamento cancelado pelo usuário.',
    paymentError: 'Erro ao processar pagamento.',
    paymentErrorDefault: 'Ocorreu um erro ao processar o pagamento. Tente novamente.',
    bookingStatus: 'Status da reserva',
    checkingStatus: 'Verificando status da reserva...',
    statusPending: 'Aguardando confirmação',
    statusConfirmed: 'Confirmada',
    statusCheckin: 'Check-in pendente',
    statusCheckedIn: 'Check-in realizado',
    statusCheckedOut: 'Check-out realizado',
    statusCancelled: 'Cancelada',
    statusNoShow: 'Não compareceu',
    statusCompleted: 'Concluída',
    statusProcessing: 'Processando...',
    hostBookingId: 'ID da reserva',
    hostCommitPendingDesc: 'A propriedade está sendo notificada sobre sua reserva.',
    paymentNotCompleted: 'Pagamento não concluído',
    paymentNotApproved: 'O pagamento não foi aprovado. Verifique os dados e tente novamente.',
    processingTimeout: 'O tempo de processamento expirou. Entre em contato com o suporte.',
    cannotConfirmPayment: 'Não foi possível confirmar o pagamento. Tente novamente.',
    paymentSystemUnavailable: 'Sistema de pagamento temporariamente indisponível.',
    cannotStartPayment: 'Não foi possível iniciar o pagamento.',
    errorStartingPayment: 'Erro ao iniciar pagamento.',
    incompletePaymentInfo: 'Informações de pagamento incompletas.',
    timeExpired: 'Tempo expirado',
    timeExpiredDesc: 'O tempo para confirmar esta reserva expirou. Faça uma nova busca para tentar novamente.',
    redoSearch: 'Refazer busca',
    hurry: 'Corra! ',
    reservationExpiresIn: 'Reserva expira em',
    minuteSingular: 'minuto',
    minutePlural: 'minutos',
    secondSingular: 'segundo',
    secondPlural: 'segundos',
    confirmed: 'Reserva Confirmada!',
    confirmedTitle: 'Reserva confirmada',
    confirmedSuccess: 'Sua reserva foi confirmada com sucesso.',
    confirmationEmailSent: 'Enviamos os detalhes para {{email}}',
    confirmationSent: 'Enviamos a confirmação para seu e-mail.',
    confirmationCode: 'Código de confirmação',
    reservationDetails: 'Detalhes da reserva',
    totalPaid: 'Total pago',
    detailsEmailed: 'Detalhes enviados por e-mail',
    backToHome: 'Voltar para início',
    cancelPolicy: 'Política de Cancelamento',
    errorPayment: 'Erro ao processar pagamento. Tente novamente.',
    pageTitle: 'Finalizar reserva - Reserve Connect',
    pageDescription: 'Finalize sua reserva no Reserve Connect. Preços reais e disponibilidade confirmada.',
    confirmationPageTitle: 'Reserva confirmada - Reserve Connect',
    confirmationPageDesc: 'Sua reserva foi confirmada com sucesso no Reserve Connect.',

    // Payment method selection
    choosePaymentMethod: 'Escolher forma de pagamento',
    cardPayment: 'Cartão de Crédito',
    cardPaymentDesc: 'Pagamento seguro via Stripe',
    pixPayment: 'PIX',
    pixPaymentDesc: 'Pagamento instantâneo via Mercado Pago',
    installmentsPayment: 'Parcelamento',
    installmentsPaymentDesc: 'Parcelamos em até 12x no cartão',
    chooseInstallments: 'Escolher número de parcelas',
    installmentsLabel: 'Parcelas',
    installmentsTotal: 'Total: {{total}}',
    installmentsNoInterest: 'Sem juros',
    selectInstallments: 'Selecione o número de parcelas',
    payInstallment: 'Pagar {{count}}x de {{value}}',

    // PIX
    pixInstructions: 'Escaneie o QR Code abaixo com seu aplicativo bancário para pagar via PIX.',
    pixCopyPaste: 'Ou copie e cole o código PIX:',
    pixWaitingPayment: 'Aguardando pagamento...',
    pixConfirmed: 'Pagamento confirmado',
    pixGenerationError: 'Erro ao gerar o QR Code PIX. Tente novamente.',
    errorStartingPix: 'Erro ao iniciar pagamento via PIX.',
    pixExpiresIn: 'Expira às {{time}}',
    paymentMethod: 'Forma de pagamento',
    copy: 'Copiar',
    installmentsInfo: 'Em até 12x no cartão',

    // Add-ons
    addOns: 'Adicionais',
    addOnsSubtitle: 'Personalize sua estadia com serviços adicionais',
    addOnsTotal: 'Adicionais',
    addOnsNone: 'Nenhum adicional selecionado',
    addOnsPricePerBooking: 'Por reserva',
    addOnsPricePerNight: 'Por noite',
    addOnsPricePerPerson: 'Por pessoa',
    addOnsContinue: 'Continuar para pagamento',
    addOnsSkip: 'Pular, quero só a hospedagem',

    // Cancellation keys
    cancelReservation: 'Cancelar Reserva',
    cancelReservationTitle: 'Cancelar reserva',
    cancelConfirmTitle: 'Tem certeza que deseja cancelar?',
    cancelConfirmDesc: 'O reembolso será calculado conforme a política de cancelamento da propriedade.',
    cancelRefundPreview: 'Você receberá {{amount}} de reembolso',
    cancelRefundFull: 'Reembolso integral',
    cancelRefundPartial50: '50% de reembolso',
    cancelRefundNone: 'Sem reembolso para esta data',
    cancelRefundCdc: 'Reembolso integral (Art. 49 CDC)',
    cancelProcessing: 'Processando cancelamento...',
    cancelSuccess: 'Reserva cancelada com sucesso',
    cancelSuccessDesc: 'Seu cancelamento foi processado. O reembolso será creditado em até 10 dias úteis.',
    cancelError: 'Não foi possível cancelar a reserva',
    cancelErrorDesc: 'Tente novamente ou entre em contato com nossa Central de Reservas.',
    cancelAlreadyCancelled: 'Esta reserva já foi cancelada.',
    cancelNotCancellable: 'Esta reserva não pode mais ser cancelada.',
    cancelDaysUntilCheckin: 'Faltam {{days}} dia(s) para o check-in',
    cancelPolicyApplied: 'Política aplicada: {{policy}}',
    cancelReason: 'Motivo do cancelamento (opcional)',
    cancelReasonPlaceholder: 'Descreva o motivo do cancelamento...',
    cancelSubmit: 'Confirmar cancelamento',
    cancelBack: 'Voltar',

    addToCalendar: 'Adicionar ao Calendário',
    addToCalendarHint: 'Baixe um arquivo .ics para Google Calendar, Apple Calendar ou Outlook',
  },
};
export default booking;
